import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    date: String // 2024-09-11 14:25:16 -0500
  }

  getPreviousMonthDate() {
    const currentDate = new Date(this.dateValue);
    const previousMonthDate = new Date(currentDate.setMonth(currentDate.getMonth() - 1));
    return previousMonthDate.toISOString().split('T')[0];
  }

  getNextMonthDate() {
    const currentDate = new Date(this.dateValue);
    const previousMonthDate = new Date(currentDate.setMonth(currentDate.getMonth() + 1));
    return previousMonthDate.toISOString().split('T')[0];
  }

  loadPreviousMonth(event) {
    event.preventDefault();
    this.loadCalendar(this.getPreviousMonthDate());
  }

  loadNextMonth(event) {
    event.preventDefault();
    this.loadCalendar(this.getNextMonthDate());
  }

  loadCalendar(dateParam) {
    fetch(`/calendars/full_calendar?date=${encodeURIComponent(dateParam)}`, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html);
    })
    .catch(error => {
      console.error("Error loading calendar:", error);
    });
  }
}
